import { useContext, useState } from "react";
import Button from "components/shared/Button";
import { Image } from "@wdpr/groot-components";
import { getCdn } from "utils";
import { Context } from "Context";
const LanguageSelectorModalWithRegionsInformation = (props) => {
	const defaultRegionSelected = () => {
		const isLocaleInRegion = (links) => {
			return links.find(({ href }) => {
				return href.search(locale) !== -1;
			});
		};
		return languageSelector.regionsInformation.find((region) =>
			isLocaleInRegion(region.links)
		);
	};
	const { containerClasses, renderLanguages, renderFullCartMessage } = props;
	const {
		headerData: { languageSelector },
		config: { locale },
		modal,
		setModal,
	} = useContext(Context);
	const [regionSelected, setRegionSelected] = useState(
		defaultRegionSelected()?.title
	);
	const iconsCdn = getCdn(true);
	const isRegionSelected = (region) => {
		return region.title === regionSelected;
	};

	const handleRegionClick = (e, region) => {
		handleRegionSelected(e, region);
	};

	const keyboardNavigation = (e, region) => {
		if (e.key === "Enter") {
			handleRegionSelected(e, region);
		}
	};

	const handleRegionSelected = (e, region) => {
		// Skip setting region if language link is selected
		if (e?.target?.tagName?.toLowerCase() !== "a") {
			setRegionSelected(region.title);
			// Reset modal so that focusable elements are reset
			setModal({ ...modal, preventFocus: true });
		}
	};

	return (
		<div className={containerClasses}>
			<div
				className={`${containerClasses} syndicated-language-selector__container__title`}
			>
				<h1>{languageSelector.title}</h1>
				<Button
					accessibleText={languageSelector?.accessibilityText}
					className="syndicated-language-selector__close__modal"
					onClick={() => setModal(false)}
					secondary="true"
					style={{
						backgroundImage: `url(${iconsCdn}/icons/pep/icon_close-reversed.svg)`,
					}}
				/>
			</div>
			{renderFullCartMessage()}
			{languageSelector.regionsInformation.map((region, key) => {
				return (
					<div
						key={key}
						className="syndicated-language-selector__container__content__body"
						onClick={(e) => handleRegionClick(e, region)}
					>
						<div
							className={`${containerClasses} syndicated-language-selector__container__column-left`}
							onKeyDown={(e) => keyboardNavigation(e, region)}
							tabIndex="0"
						>
							{region.image && (
								<Image
									image={{
										url: `${region.image.url}`,
										title: `${region.image.id}`,
									}}
								/>
							)}
							<h3>{region.title}</h3>
						</div>

						<div
							className={`${containerClasses} syndicated-language-selector__container__column-right`}
						>
							{isRegionSelected(region) && renderLanguages(region.links)}
						</div>
					</div>
				);
			})}
		</div>
	);
};
export default LanguageSelectorModalWithRegionsInformation;
